module.exports = __webpack_public_path__ + "img/555417.e6679990.png";